// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"wifi"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.10059 9.10049C7.56793 3.63315 16.4323 3.63319 21.8996 9.10049M6.69678 13.6967C9.62572 10.7677 14.3745 10.7678 17.3034 13.6967M11.293 18.2929C11.6835 17.9024 12.3167 17.9024 12.7072 18.2929L12.0001 19L11.293 18.2929Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const WifiIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wifi',
    ref,
    icon: element,
  },
));

WifiIcon.displayName = 'WifiIcon';

export default WifiIcon;
